exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-box{margin:15% auto;width:400px;border:1px solid #487bb0;border-radius:6px}.login-box .login-header{color:#487bb0;padding:10px;border-bottom:1px solid #487bb0}.login-box .login-body{padding:20px 40px}.login-box .login-body .el-row{margin-bottom:20px}.login-box .login-body .el-row:last-child{margin-bottom:0}.login-box .login-body .msg-error{position:relative;background:#ffebeb;color:#e4393c;border:1px solid #faccc6;line-height:15px;font-size:13px;padding:3px 10px;margin-bottom:10px}.login-box .login-body .msg-error i{margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-22aa21e0","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Login.vue
// module id = 974
// module chunks = 1